import PropTypes from 'prop-types';
import React from 'react';

// Styles.
import './modal-contents.scss';

const ModalContents = ({
  children,
  dismiss,
}) => (
  <div className="kauffman-modal-contents">
    <button
      className="kauffman-modal-close"
      onClick={dismiss}
    >
      <span className="screen-reader-text">Close</span>
    </button>
    {children}
  </div>
);

ModalContents.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  dismiss: PropTypes.func.isRequired,
};

export default ModalContents;
